import React from 'react';

import cx from 'classnames';
import { useSelector } from 'react-redux';

import Icon from 'components/shared/Icon';
import Collapse from 'components/shared/Icon/icons/Collapse';
import UnCollapse from 'components/shared/Icon/icons/UnCollapse';
import Tooltip, { TooltipText, VARIANTS } from 'components/shared/Tooltip';
import Text from 'components/shared/Typography/Text';
import { tripEventsSelector } from 'store/itinerariesItem/chronologicalDetails/selectors';

import { useCollapseDays } from '../functions';
import s from './index.module.css';

export const CollapseButton = ({ withText }: { withText?: boolean }) => {
  const { isCollapsed, setCollapsedDays } = useCollapseDays();
  const tripEvents = useSelector(tripEventsSelector);
  const isDisabled = tripEvents.length === 0;
  const iconFill = withText ? 'transparent' : '#EEEEEE';

  return (
    <div
      data-tip=""
      data-for="collapse"
      className={cx({ [s.collapseButtonWrapper]: withText, [s['collapseButtonWrapper-disabled']]: isDisabled })}
      onClick={() => setCollapsedDays(!isCollapsed)}
    >
      <Icon
        disabled={isDisabled}
        component={isCollapsed ? () => <UnCollapse fill={iconFill} /> : () => <Collapse fill={iconFill} />}
        className={cx(s.icon, s.collapseIcon, isDisabled && s.disabledIcon, withText && s['collapseIcon-withText'])}
      />

      {withText && (
        <Text className={cx(s.collapseButtonText, isDisabled && s['collapseButtonText-disabled'])}>
          {isCollapsed ? 'Show Content' : 'Collapse Content'}
        </Text>
      )}

      <Tooltip variant={VARIANTS.DARK} className={s.tooltip} id="collapse" disable={withText}>
        <TooltipText className={s.tooltipText}>{isCollapsed ? 'Show Content' : 'Collapse Content'}</TooltipText>
      </Tooltip>
    </div>
  );
};
